const UNITS = ['B', 'KB', 'MB', 'GB'];

export function formatBytes(bytes, locale) {
  if (bytes === null || bytes === undefined) {
    return '—';
  }

  let value = Number(bytes);
  let unit = 0;

  while (value >= 1024 && unit < UNITS.length - 1) {
    value /= 1024;
    unit += 1;
  }

  const digits = unit === 0 || value >= 100 ? 0 : 1;

  return `${new Intl.NumberFormat(locale, { maximumFractionDigits: digits }).format(value)} ${UNITS[unit]}`;
}

/** `createdAt` is Unix epoch seconds, like every date the media table keeps. */
export function formatMediaDate(createdAt, locale) {
  if (!createdAt) {
    return '—';
  }

  return new Intl.DateTimeFormat(locale, {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(createdAt * 1000));
}

/**
 * Stored names are content digests, which say nothing to a reader: the
 * description comes first, then a short form of the digest.
 */
export function mediaDisplayName(media) {
  if (media.description?.trim()) {
    return media.description.trim();
  }

  const extension = media.extension ? `.${media.extension}` : '';

  return `${media.fileName.slice(0, 12)}…${extension}`;
}
